import { render, staticRenderFns } from "./authorpop.vue?vue&type=template&id=2bcd191d"
import script from "./authorpop.vue?vue&type=script&lang=js"
export * from "./authorpop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports